<div class="grid md:grid-cols-{{componentModel.columnsMd.value}} lg:grid-cols-{{componentModel.columnsXl.value}} lg:gap-4 md:gap-2 gap-y-2">

        @switch (componentModel.cardComponent?.value){
            @case (CardTypes.member){
                @for(item of componentModel.cards.value; track $index){
                        <div>
                            <white-label-team-card [componentModel]="item"></white-label-team-card>
                        </div>
                }
            }
            @case (CardTypes.blog){
                @for(item of componentModel.cards.value; track $index){
                        <div>
                            <white-label-blog-card [componentModel]="item"></white-label-blog-card>
                        </div>
                }
            }
            @case (CardTypes.media){
                @for(item of componentModel.cards.value; track $index){
                        <div>
                            <white-label-media-card [componentModel]="item"></white-label-media-card>
                        </div>
                }
            }
            @case (CardTypes.event){
                @for(item of componentModel.cards.value; track $index){
                        <div>
                            <white-label-event-card [componentModel]="item"></white-label-event-card>
                        </div>
                }
            }
            @case (CardTypes.feature){
                @for(item of componentModel.cards.value; track $index){
                        <div>
                            <white-label-feature-card [componentModel]="item" [mainClass]="'min-h-full'"></white-label-feature-card>
                        </div>
                }
            }
            @default {
                @for(item of componentModel.cards.value; track $index){
                        <div>
                            <white-label-default-card [componentModel]="item"></white-label-default-card>
                        </div>
                }
            }
        }
</div>